"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");

var stream_1 = require("stream");
/**
 * Serializes SPARQL results for testing and debugging.
 */


var ActorSparqlSerializeStats =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeStats, _bus_sparql_serialize);

  function ActorSparqlSerializeStats(args) {
    _classCallCheck(this, ActorSparqlSerializeStats);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeStats).call(this, args));
  }

  _createClass(ActorSparqlSerializeStats, [{
    key: "testHandleChecked",
    value: function () {
      var _testHandleChecked = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(['bindings', 'quads'].indexOf(action.type) < 0)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle bindings streams or quad streams.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testHandleChecked(_x, _x2) {
        return _testHandleChecked.apply(this, arguments);
      }

      return testHandleChecked;
    }()
  }, {
    key: "pushHeader",
    value: function pushHeader(data) {
      var header = ['Result', 'Delay (ms)'].join(',');
      data.push(header + '\n');
    }
  }, {
    key: "pushStat",
    value: function pushStat(data, startTime, result) {
      var row = [result, this.delay(startTime)].join(',');
      data.push(row + '\n');
    }
  }, {
    key: "pushFooter",
    value: function pushFooter(data, startTime) {
      var footer = ['TOTAL', this.delay(startTime)].join(',');
      data.push(footer + '\n');
      data.push(null);
    }
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType, context) {
        var _this = this;

        var data, resultStream, startTime, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable();

                data._read = function () {
                  return;
                };

                resultStream = action.type === 'bindings' ? action.bindingsStream : action.quadStream; // TODO: Make initiation timer configurable

                startTime = process.hrtime();
                result = 1;
                this.pushHeader(data);
                resultStream.on('error', function (e) {
                  return data.emit('error', e);
                });
                resultStream.on('data', function () {
                  return _this.pushStat(data, startTime, result++);
                });
                resultStream.on('end', function () {
                  return _this.pushFooter(data, startTime);
                });
                return _context2.abrupt("return", {
                  data: data
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runHandle(_x3, _x4, _x5) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }, {
    key: "delay",
    value: function delay(startTime) {
      var time = process.hrtime(startTime);
      return time[0] * 1000 + time[1] / 1000000;
    }
  }]);

  return ActorSparqlSerializeStats;
}(bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes);

exports.ActorSparqlSerializeStats = ActorSparqlSerializeStats;